import types from './actionTypes';
import { saleFilters } from '../../../config/filters';

const initialState = {
  loading: false,
  insights: [],
  startDate: null,
  endDate: null,
  filters: { ...saleFilters },
  error: '',
};

const dailySaleInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DAILY_SALE_INSIGHT_STATE:
      return initialState;
    case types.DAILY_SALE_INSIGHTS.REQUEST:
      return {
        ...state,
        loading: true,
        insights: [],
        error: '',
      };
    case types.DAILY_SALE_INSIGHTS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        insights: action.insights,
        startDate: action.startDate,
        endDate: action.endDate,
        filters: { ...action.filters },
      };
    case types.DAILY_SALE_INSIGHTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default dailySaleInsightsReducer;
